module.exports = new __parcel__URL__("eradicatorwarlock.a8d70769.png").toString();